import React, { useState } from 'react';
import { Box, CircularProgress, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Typography, Stack } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
// icons
import CloseIcon from '@mui/icons-material/Close';
// utils and helpers
import { closeCustomModalDialog } from "../../../redux/slices/modalSlice";
import { setModalLoader } from "../../../redux/slices/modalSlice";
import { updateAssignedProducts } from "../../../redux/slices/hyperwolf/inventoryDistribution";
import { openSnackbar } from "../../../redux/slices/common";
// custom components
import MDButton from 'components/MDButton';

export default function PlannerOverrideNotes({ closeModal }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user = {} } = useSelector((state) => state.auth || {})
  const { modalData, isLoading = false } = useSelector(state => state.modal);
  const { templateId, selectedProducts, selectedBoxes, selectedBulkQuantity } = modalData || {};

  const [plannerOverrideNotes, setPlannerOverrideNotes] = useState("");

  const handleChange = (e) => {
    const { value } = e.target;
    setPlannerOverrideNotes(value)
  }

  const handleSave = async (plannerOverrideNotes) => {
    if (isLoading) return;
    dispatch(setModalLoader(true));

    try {
      const request = {
        templateId,
        plannerOverrideNotes: { note: plannerOverrideNotes, updatedBy: user.name },
        products: selectedProducts,
        boxes: selectedBoxes,
        ...selectedBulkQuantity
      };

      const response = await dispatch(updateAssignedProducts(request)).unwrap();
      if (response?.data) {
        dispatch(closeCustomModalDialog());
        navigate(`/hyperwolf/kit-template/view-template/${templateId}`);
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.message || error?.message || error;
      dispatch(openSnackbar({ content: errorMsg, color: "error", icon: "warning", }));
    } finally {
      dispatch(setModalLoader(false));
    }
  }

  return (
    <>
      <DialogTitle className='pt-4 px-4 pb-1'>
        <Typography variant="h4" fontWeight="bold">
          Planner Override Notes
        </Typography>
        <IconButton onClick={closeModal} edge='end' size='small' style={{ position: "absolute", right: "24px", top: "24px" }}>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>
      <DialogContent className='px-4 py-0'>
        <Typography variant="body2" sx={{ mb: 3, color: "#656575", fontSize: "16px" }}>
          Please explain why you are overriding this template.
        </Typography>
        <Box className="cus-contents cus-modal-contents">
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            className="form-input"
            placeholder="Add Notes..."
            name='metaDescription'
            value={plannerOverrideNotes}
            onChange={handleChange}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "start" }} className='p-4'>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={1}>
          {/* <MDButton
            onClick={closeModal}
            sx={{ minWidth: '160px' }}
            type='button'
            variant='outlined'
            color='dark'
          >
            Cancel
          </MDButton> */}
          <MDButton
            onClick={() => handleSave(plannerOverrideNotes)}
            sx={{ minWidth: '160px' }}
            color="primary"
            type='button'
            variant='contained'
          >
            {isLoading ? <CircularProgress size={16} color='light' /> : ' Save'}
          </MDButton>
        </Stack>
      </DialogActions>
    </>
  );
}